module.exports = __webpack_public_path__ + "5f298af5529e4f0d6aa09de99ba6a4f1.png";